import * as yup from 'yup';

export const validationPasswordSchema = yup.object({
    password: yup
        .string()
        .required('Required')
        .oneOf([yup.ref('passwordconfirm'), null], 'Password not matched'),
    passwordconfirm: yup
        .string()
        .required('Required')
        .oneOf([yup.ref('password'), null], 'Password not matched'),
})

export const validationSchema = yup.object({
    status: yup
        .string()
        .required("Required"),
    username: yup
        .string()
        .required("Required"),
    firstname: yup
        .string()
        .required("Required"),
    lastname: yup
        .string()
        .required("Required"),
    email: yup
        .string()
        .email('Enter a valid email')
        .required("Required"),
    contact: yup
        .string()
        .required("Required"),
}).required();

export const validationBranchSchema = yup.object({
    branchAccessId: yup
        .array()
        .of(yup.string())
        .min(1, "Min 1 selection")
        .required('Required'),
})

export const initialPasswordValues = {
    password:"",
    passwordconfirm:"",
}

export const initialBranchValues = {
    branchAccessId: []
}

export const initialValues = {
    status: true,
    username: "",
    firstname: "",
    lastname: "",
    email:"",
    contact: "",
    userId: "",
    // parentUserId: ""
    // props: {}
}